import { useState } from 'react';
import { usarComodinLogica, resetComodinesLogica } from '../utils/quizComodines';

// Hook personalizado para manejar los comodines del quiz
const useQuizComodines = () => {
  const [comodines, setComodines] = useState({
    llamada: 1,
    publico: 1,
    cincuenta: 1,  // Nuevo comodín 50/50
    mago: 1        // Nuevo comodín mago
  });

  // Estados para el temporizador del comodín de la llamada
  const [tiempoLlamada, setTiempoLlamada] = useState(30);
  const [temporizadorLlamadaActivo, setTemporizadorLlamadaActivo] = useState(false);
  const [mostrarTemporizadorLlamada, setMostrarTemporizadorLlamada] = useState(false);

  // Estados para el comodín del público
  const [mostrarGraficoPublico, setMostrarGraficoPublico] = useState(false);
  const [datosGraficoPublico, setDatosGraficoPublico] = useState(null);
  const [tiempoRestantePublico, setTiempoRestantePublico] = useState(30);
  const [temporizadorPublicoActivo, setTemporizadorPublicoActivo] = useState(false);
  const [votosPublico, setVotosPublico] = useState([0, 0]);

  // Permite pasar un callback extra para el mago
  const usarComodin = (tipo, respuestasVisibles, respuestaRevelada, preguntaActual, respuestas, respuestasMezcladas, setRespuestasVisibles, setRespuestasEliminadas, forzar = false, extra = {}) => {
    return usarComodinLogica(
      tipo,
      comodines,
      setComodines,
      respuestasVisibles,
      respuestaRevelada,
      preguntaActual,
      respuestasMezcladas,
      setRespuestasVisibles,
      setRespuestasEliminadas,
      setTiempoLlamada,
      setTemporizadorLlamadaActivo,
      setMostrarTemporizadorLlamada,
      setMostrarGraficoPublico,
      setTiempoRestantePublico,
      setTemporizadorPublicoActivo,
      forzar,
      extra
    );
  };

  const resetComodines = () => {
    resetComodinesLogica(
      setComodines,
      setMostrarTemporizadorLlamada,
      setTemporizadorLlamadaActivo,
      setTiempoLlamada,
      setMostrarGraficoPublico,
      setTemporizadorPublicoActivo,
      setTiempoRestantePublico
    );
  };

  return {
    comodines,
    tiempoLlamada,
    temporizadorLlamadaActivo,
    mostrarTemporizadorLlamada,
    mostrarGraficoPublico,
    datosGraficoPublico,
    tiempoRestantePublico,
    temporizadorPublicoActivo,
    votosPublico,
    usarComodin,
    resetComodines,
    setComodines,
    setTiempoLlamada,
    setTemporizadorLlamadaActivo,
    setMostrarTemporizadorLlamada,
    setMostrarGraficoPublico,
    setDatosGraficoPublico,
    setTiempoRestantePublico,
    setTemporizadorPublicoActivo,
    setVotosPublico
  };
};

export default useQuizComodines;
